import { Injectable } from '@angular/core';
import { requestWithToken } from 'src/config';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  async logoutUser() {
    return requestWithToken(
      "POST",
      "/user/logout",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }
}
